import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Po from './Po';
import Do from './Do';
import Ts from './Ts';
import Mobilfree from './Mobilfree';
import Bk from './Bk';
import Hk from './Hk';
import LapHk from './LapHk';
import LapSJ from './LapSJ';
import LapKM from './LapKM';
import LapDaily from './LapDaily';
import LastPosition from './LastPosition';
import LapMG from './LapMG';
import LapJBM from './LapJBM';
import LapMastergaji from './LapMastergaji';
import MasterInvoice from './MasterInvoice';
import LapKinerja from './LapKinerja';

function Dashboard() {
  const location = useLocation();
  const navigate = useNavigate();
  const tusername = location.state?.tusername;

  const schema = localStorage.getItem('schema');
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [activeSection, setActiveSection] = useState('');
  const [activeMenu, setActiveMenu] = useState('');
  const [showSidebar, setShowSidebar] = useState(false);
  const [access, setAccess] = useState({ po: false,  do: false, ts: false, mobilfree: false, lap_hk: false, 
      lap_sj: false, LastPosition: false, lap_daily: false, lap_mg: false, lap_jbm: false, lap_km: false, mi: false, 
      bk: false, lap_kinerja: false, hk: false, });  

  useEffect(() => {
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    if (!isLoggedIn) navigate('/');

    setAccess({
      po: localStorage.getItem('po_access') !== 'F',
      do: localStorage.getItem('do_access') !== 'F',
      ts: localStorage.getItem('ts_access') !== 'F',
      mobilfree: localStorage.getItem('mobilfree_access') !== 'F',
      hk: localStorage.getItem('hk_access') !== 'F',
      lap_hk: localStorage.getItem('lap_hk_access') !== 'F',
      lap_sj: localStorage.getItem('lap_sj_access') !== 'F',
      lap_daily: localStorage.getItem('lap_daily') !== 'F',
      lap_mg: localStorage.getItem('lap_mg_access') !== 'F',
      lap_jbm: localStorage.getItem('lap_jbm_access') !== 'F',
      lastposition: localStorage.getItem('lastposition_access') !== 'F',
      lap_km: localStorage.getItem('lap_km_access') !== 'F',
      mi: localStorage.getItem('mi_access') !== 'F',
      bk: localStorage.getItem('bk_access') !== 'F',
      lap_kinerja: localStorage.getItem('lap_kinerja_access') !== 'F',
    });
  }, [navigate]);


  useEffect(() => {
    const handleBeforeUnload = () => localStorage.removeItem('isLoggedIn');
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('isLoggedIn');
    navigate('/');
  };

  const toggleMenu = (menu) => {
    setActiveMenu(activeMenu === menu ? '' : menu);
  };

  const renderContent = () => {
    if (activeSection === 'Po') return <Po />;
    if (activeSection === 'Do') return <Do />;
    if (activeSection === 'Ts') return <Ts />;
    if (activeSection === 'Mobilfree') return <Mobilfree />;
    if (activeSection === 'Bk') return <Bk />;
    if (activeSection === 'Hk') return <Hk />;
    if (activeSection === 'LapHk') return <LapHk />;
    if (activeSection === 'LapSJ') return <LapSJ />;
    if (activeSection === 'LapMG') return <LapMG />;
    if (activeSection === 'LapJBM') return <LapJBM />;
    if (activeSection === 'LapDaily') return <LapDaily />;
    if (activeSection === 'LastPosition') return <LastPosition />;
    if (activeSection === 'LapMastergaji') return <LapMastergaji />;
    if (activeSection === 'LapKM') return <LapKM />;
    if (activeSection === 'MasterInvoice') return <MasterInvoice />;
    if (activeSection === 'LapKinerja') return <LapKinerja />;
    return <h2>Welcome, {tusername} @ {schema}</h2>;
  };

  const styles = {
    container: {display: 'flex', flexDirection: isMobile ? 'column' : 'row', minHeight: '100vh',},
    sidebar: {width: isMobile ? '100%' : '180px', backgroundColor: '#2C3E50', color: 'white', padding: '10px 20px',
      boxSizing: 'border-box', display: showSidebar || !isMobile ? 'block' : 'none', position: isMobile ? 'relative' : 'fixed', zIndex: 2,},
    menuItem: { padding: '10px', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#34495E', marginBottom: '5px', borderRadius: '4px', },
    subMenu: { backgroundColor: '#3B4A5A', padding: '10px', marginLeft: '10px',},
    subMenuItem: {padding: '5px 0', cursor: 'pointer',},
    content: {flex: 1, padding: '20px', marginLeft: isMobile ? '0' : '180px', backgroundColor: '#f9f9f9',},
    toggleButton: {display: isMobile ? 'block' : 'none', backgroundColor: '#2C3E50', color: 'white', padding: '10px', border: 'none', textAlign: 'left',},
  };    

  return (
    <div style={styles.container}>
      <button style={styles.toggleButton} onClick={() => setShowSidebar(!showSidebar)}>
        ☰ Menu
      </button>

      <div style={styles.sidebar}>
        <div
          style={{
            textAlign: 'center',
            fontWeight: 'bold',
            marginBottom: '15px',
            padding: '10px',
            borderRadius: '4px',
          }}
        >
        {schema?.toUpperCase() || '-'}
        </div>

        <div style={styles.menuItem} onClick={() => toggleMenu('master')}>
          Master
          <span>{activeMenu === 'master' ? '-' : '+'}</span>
        </div>
        {activeMenu === 'master' && (
          <div style={styles.subMenu}>
            <div
              style={{...styles.subMenuItem,  color: access.ts ? 'white' : 'gray',  pointerEvents: access.ts ? 'auto' : 'none',  opacity: access.ts ? 1 : 0.5,  }}
              onClick={() => { if (access.ts) setActiveSection('LapMastergaji');  }}
            >
              Gaji
            </div>

            <div
              style={{...styles.subMenuItem,  color: access.mi ? 'white' : 'gray',  pointerEvents: access.mi ? 'auto' : 'none',  opacity: access.mi ? 1 : 0.5,  }}
              onClick={() => { if (access.mi) setActiveSection('MasterInvoice');  }}
            >
              Invoice
            </div>


          </div>
        )}


        <div style={styles.menuItem} onClick={() => toggleMenu('operasional')}>
          Operasional
          <span>{activeMenu === 'operasional' ? '-' : '+'}</span>
        </div>
        {activeMenu === 'operasional' && (
          <div style={styles.subMenu}>
            <div
              style={{...styles.subMenuItem,  color: access.po ? 'white' : 'gray',  pointerEvents: access.po ? 'auto' : 'none',  opacity: access.po ? 1 : 0.5,  }}
              onClick={() => { if (access.po) setActiveSection('Po');  }}
            >
              PO
            </div>

            <div
              style={{...styles.subMenuItem, color: access.do ? 'white' : 'gray',  pointerEvents: access.do ? 'auto' : 'none',  opacity: access.do ? 1 : 0.5, }}
              onClick={() => { if (access.do) setActiveSection('Do'); }}
            >
              DO
            </div>

            <div
              style={{...styles.subMenuItem,  color: access.ts ? 'white' : 'gray',  pointerEvents: access.ts ? 'auto' : 'none',  opacity: access.ts ? 1 : 0.5, }}
              onClick={() => { if (access.ts) setActiveSection('Ts');  }}
            >
              TS
            </div>


            <div
              style={{...styles.subMenuItem,  color: access.mobilfree ? 'white' : 'gray',  pointerEvents: access.mobilfree ? 'auto' : 'none',  opacity: access.mobilfree ? 1 : 0.5, }}
              onClick={() => { if (access.mobilfree) setActiveSection('Mobilfree');  }}
            >
              Mobil Free
            </div>

            <div
              style={{...styles.subMenuItem,  color: access.bk ? 'white' : 'gray',  pointerEvents: access.bk ? 'auto' : 'none',  opacity: access.bk ? 1 : 0.5, }}
              onClick={() => { if (access.bk) setActiveSection('Bk');  }}
            >
              BK
            </div>

            <div
              style={{...styles.subMenuItem,  color: access.hk ? 'white' : 'gray',  pointerEvents: access.hk ? 'auto' : 'none',  opacity: access.hk ? 1 : 0.5, }}
              onClick={() => { if (access.hk) setActiveSection('Hk');  }}
            >
              HK
            </div>

          </div>
        )}

        <div style={styles.menuItem} onClick={() => toggleMenu('laporan')}>
          Laporan
          <span>{activeMenu === 'laporan' ? '-' : '+'}</span>
        </div>
        {activeMenu === 'laporan' && (
          <div style={styles.subMenu}>
            <div
              style={{...styles.subMenuItem,  color: access.lap_hk ? 'white' : 'gray',  pointerEvents: access.lap_hk ? 'auto' : 'none',  opacity: access.lap_hk ? 1 : 0.5, }}
              onClick={() => {  if (access.lap_hk) setActiveSection('LapHk');  }}
            >
              HK
            </div>

            <div
              style={{...styles.subMenuItem, color: access.lap_sj ? 'white' : 'gray', pointerEvents: access.lap_sj ? 'auto' : 'none',  opacity: access.lap_sj ? 1 : 0.5,  }}
              onClick={() => { if (access.lap_sj) setActiveSection('LapSJ');  }}
            >
              SJ
            </div>

            <div
              style={{...styles.subMenuItem, color: access.lap_mg ? 'white' : 'gray', pointerEvents: access.lap_mg ? 'auto' : 'none',  opacity: access.lap_mg ? 1 : 0.5,  }}
              onClick={() => { if (access.lap_mg) setActiveSection('LapMG');  }}
            >
              MG
            </div>

            <div
              style={{...styles.subMenuItem, color: access.lap_jbm ? 'white' : 'gray', pointerEvents: access.lap_jbm ? 'auto' : 'none',  opacity: access.lap_jbm ? 1 : 0.5,  }}
              onClick={() => { if (access.lap_jbm) setActiveSection('LapJBM');  }}
            >
              JBM
            </div>              

            <div
              style={{...styles.subMenuItem, color: access.lap_km ? 'white' : 'gray', pointerEvents: access.lap_km ? 'auto' : 'none',  opacity: access.lap_km ? 1 : 0.5,  }}
              onClick={() => { if (access.lap_km) setActiveSection('LapKM');  }}
            >
              KM
            </div>

            <div
              style={{...styles.subMenuItem, color: access.lap_kinerja ? 'white' : 'gray', pointerEvents: access.lap_kinerja ? 'auto' : 'none',  opacity: access.lap_kinerja ? 1 : 0.5,  }}
              onClick={() => { if (access.lap_kinerja) setActiveSection('LapKinerja');  }}
            >
              Kinerja
            </div>                

            <div
              style={{...styles.subMenuItem, color: access.lap_daily ? 'white' : 'gray', pointerEvents: access.lap_daily ? 'auto' : 'none',  opacity: access.lap_daily ? 1 : 0.5,  }}
              onClick={() => { if (access.lap_daily) setActiveSection('LapDaily');  }}
            >
              Harian
            </div>

            <div
              style={{...styles.subMenuItem, color: access.lastposition ? 'white' : 'gray', pointerEvents: access.lastposition ? 'auto' : 'none',  opacity: access.lastposition ? 1 : 0.5,  }}
              onClick={() => { if (access.lastposition) setActiveSection('LastPosition');  }}
            >
              GPS
            </div>                
          </div>
        )}

        <div style={styles.menuItem} onClick={handleLogout}>Logout</div>
      </div>

      <div style={styles.content}>{renderContent()}</div>
    </div>
  );

}



export default Dashboard;
